<template>
    <div class="data-deletion">
      <el-image :src="data_header" class="data-header-img"></el-image>
      <el-image :src="data_main" class="data-main-img"></el-image>
    </div>
</template>

<script>
    export default {
        name: "DataDelete",
        data() {
           return {
             data_header: `${require('../assets/img_11_23/data_deletion_2.png')}`,
             data_main: `${require('../assets/img_11_23/data_main_2.png')}`,
           }
        }
    }
</script>

<style scoped>
  .data-deletion {
    width: 85%;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-bottom: -6%;
  }
  .data-header-img {
    width: 100%;
    margin-bottom: 3%;
    margin-top: 10%;
  }
  .data-main-img {
    width: 100%;
    margin-bottom: 10%;
  }
  @media screen and (max-width: 992px) {
    .data-header-img {
      margin-top: 20%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/DataDelete.vue